import { Event, ItemsData } from '../google-tag-manager-pusher/GoogleTagManagerPusher'
import { BasketItem } from '../../schema/basket'
import { WebshopPackage } from '../../schema/webshop-package'
import { siteAbbreviationByAlias } from '../../schema/mappers/site'

const webshopPackageToBrand = (product: WebshopPackage): string =>
  [...(product.jobPosting?.publishOn || []), ...(product.upgrades?.flatMap(upgrade => upgrade.requiredSites) || [])]
    .filter(value => value)
    .filter((value, index, self) => self.indexOf(value) === index)
    .map(value => siteAbbreviationByAlias(value) || value)
    .map(value => value.toUpperCase())
    .join(' - ')

export const basketItemsToItemsData = (basketItems: BasketItem[], event: Event): ItemsData => ({
  currency: 'EUR',
  event,
  value: basketItems.reduce((previous, current) => previous + (current.price || 0), 0),
  items: basketItems.map((item, index) => ({
    item_id: item.product?.productCode || '',
    item_name: item.product?.name || '',
    index,
    item_brand: item.product && webshopPackageToBrand(item.product),
    price: item.price,
    quantity: item.amount,
  })),
})
